import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, catchError } from 'rxjs';
import { Router } from '@angular/router';

/**
 * Interceptor that checks for 403 responses with 'incomplete_profile' status
 * and redirects the user to the creator profile page.
 */
export const profileCompletionInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check if the error is a 403 with 'incomplete_profile' status
      if (
        error.status === 403 &&
        error.error &&
        error.error.status === 'incomplete_profile'
      ) {
        // Redirect to creator profile page only if not already there to avoid double navigation
        if (router.url !== '/account/creator-profile') {
          router.navigate(['/account/creator-profile']);
        }
      }

      // Re-throw the error to be handled by the application
      return throwError(() => error);
    })
  );
};
